/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const order_not_found_busy = () => `Wenn Sie gerade Tickets gekauft haben, kann es sein, dass unsere Systeme ausgelastet sind. Bitte warten Sie einige Minuten und versuchen Sie es erneut. Sie sollten in Kürze eine E-Mail mit Ihren Tickets erhalten.`
